import { render, staticRenderFns } from "./PolicyCheckIn.vue?vue&type=template&id=3bb6f0a2"
import script from "./PolicyCheckIn.vue?vue&type=script&lang=js"
export * from "./PolicyCheckIn.vue?vue&type=script&lang=js"
import style0 from "./PolicyCheckIn.vue?vue&type=style&index=0&id=3bb6f0a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports